module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-medical-2d9d20d7.svg";